import {CurrentPipelineColumns} from "./currentPipelineColumns";

export class CurrentPipeline {
    active;
    inNegotiation;
    underContract;
    totalNegUc;
    inNegUcOther;
    closedYTD;
    closedYTDOther;
    totalClosedYTD;

    constructor({activeData, inNegotiationData, underContractData, inNegUcOtherData, closedYTDData, closedYTDOtherData}) {
        this.active = new CurrentPipelineColumns({status: 'Active', data: activeData});
        this.inNegotiation = new CurrentPipelineColumns({status: 'In Negotiation', data: inNegotiationData});
        this.underContract = new CurrentPipelineColumns({status: 'Under Contract', data: underContractData});
        this.totalNegUc = new CurrentPipelineColumns({status: 'Total (Neg/UC)', negData: this.inNegotiation, ucData: this.underContract});
        this.inNegUcOther = new CurrentPipelineColumns({status: 'Other Neg/UC', data: inNegUcOtherData});
        this.closedYTD = new CurrentPipelineColumns({status: 'Closed YTD', data: closedYTDData});
        this.closedYTDOther = new CurrentPipelineColumns({status: 'Other Closed YTD', data: closedYTDOtherData});
        this.totalClosedYTD = new CurrentPipelineColumns({status: 'Total Closed YTD', closedData: this.closedYTD, closedOtherData: this.closedYTDOther});
    }
}
